package com.example.readingnotes.data.repository

import com.example.readingnotes.data.remote.api.ApiClient
import com.example.readingnotes.data.remote.dto.CreateTagRequest
import com.example.readingnotes.data.remote.dto.UpdateTagRequest
import com.example.readingnotes.data.remote.mapper.TagMapper
import com.example.readingnotes.domain.model.Tag
import com.example.readingnotes.domain.model.TagWithCount
import com.example.readingnotes.domain.repository.TagRepository

class TagRepositoryImpl(
    private val apiClient: ApiClient,
) : TagRepository {
    override suspend fun getAllTags(): Result<List<Tag>> =
        try {
            val dtos = apiClient.getTags()
            Result.success(dtos.map { TagMapper.toDomain(it) })
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun getTagById(id: Int): Result<Tag?> =
        try {
            val dto = apiClient.getTag(id)
            Result.success(TagMapper.toDomain(dto))
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun getPopularTags(limit: Int): Result<List<TagWithCount>> =
        try {
            val dtos = apiClient.getPopularTags(limit)
            Result.success(dtos.map { TagMapper.toDomain(it) })
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun getTagsForPost(postId: Int): Result<List<Tag>> =
        try {
            val dtos = apiClient.getTagsForPost(postId)
            Result.success(dtos.map { TagMapper.toDomain(it) })
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun createTag(name: String, color: String?): Result<Tag> =
        try {
            val request = CreateTagRequest(name = name, color = color)
            val dto = apiClient.createTag(request)
            Result.success(TagMapper.toDomain(dto))
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun updateTag(id: Int, name: String?, color: String?): Result<Tag> =
        try {
            val request = UpdateTagRequest(name = name, color = color)
            val dto = apiClient.updateTag(id, request)
            Result.success(TagMapper.toDomain(dto))
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun deleteTag(id: Int): Result<Boolean> =
        try {
            apiClient.deleteTag(id)
            Result.success(true)
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun addTagToPost(postId: Int, tagId: Int): Result<Unit> =
        try {
            apiClient.addTagToPost(postId, tagId)
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun removeTagFromPost(postId: Int, tagId: Int): Result<Boolean> =
        try {
            apiClient.removeTagFromPost(postId, tagId)
            Result.success(true)
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun searchTags(query: String): Result<List<Tag>> =
        try {
            val dtos = apiClient.searchTags(query)
            Result.success(dtos.map { TagMapper.toDomain(it) })
        } catch (e: Exception) {
            Result.failure(e)
        }
}
